import React, { useState, useEffect } from 'react';
import RichTextEditor from '../../Components/RichTextEditor';
import {
    Box, Grid, TextField, Button, Typography, Divider, Paper,
    Stepper, Step, StepLabel, FormControl, InputLabel, Select, MenuItem, Stack, Autocomplete,useTheme,alpha,IconButton,Avatar,
  Checkbox, FormControlLabel, Chip, ToggleButton, Dialog, DialogTitle, DialogContent, InputAdornment, DialogActions
} from '@mui/material';
import {
  MdVisibility,
  MdVisibilityOff,
  MdImage,
  MdLocalOffer,
  MdCategory,
  MdCurrencyRupee,
  MdInfo,
  MdScale,
  MdSchedule,
  MdStar,
  MdChevronLeft,
  MdChevronRight,
  MdShoppingBag
} from 'react-icons/md';
import { FaEdit, FaEye } from 'react-icons/fa';
import { FiX, FiType, FiUploadCloud, FiTrash2, FiCircle, FiLayers } from 'react-icons/fi';
import { postFileUpload } from '../../Webservice/webservice';


const steps = ['Basic Information', 'Product Details', 'Price Details', 'Dimensions',  'Additional Information','Review'];

const ProductForm = ({
    form,
    onFormChange,
    onCancel,
    onSubmit,
    isSubmitDisabled,
    categories = [],
    subcategories = [],
    isEdit = false,
    formMode = 'edit',
    handleFormModeChange = null
}) => {
    const [activeStep, setActiveStep] = useState(0);

    // Quill editor configuration
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const [activeImageIndex, setActiveImageIndex] = useState(0);
    const calculateDiscountedPrice = () => {
  if (!form.b2c_discountType || !form.b2c_discountValue) return form.b2c_sellingPrice || form.b2c_mrp;
  
  const price = parseFloat(form.b2c_sellingPrice || form.b2c_mrp);
  const discount = parseFloat(form.b2c_discountValue);
  
  if (form.b2c_discountType === 'percentage') {
    return Math.round(price - (price * discount / 100));
  } else {
    return Math.round(price - discount);
  }
};
    const scrollContainerRef = React.useRef(null);
    const scrollLeft = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: -200, behavior: 'smooth' });
        }
    };
    const scrollRight = () => {
        if (scrollContainerRef.current) {
            scrollContainerRef.current.scrollBy({ left: 200, behavior: 'smooth' });
        }
    };
    const [addOpen, setAddOpen] = useState(false);
    const [addSubOpen, setAddSubOpen] = useState(false);
    const [imagePreview, setImagePreview] = useState('');
    const [newCategory, setNewCategory] = useState({
        title: '',
        image: '',
        status: 'active'
    });
    const [newSubcategory, setNewSubcategory] = useState({
        title: '',
        category_id: '',
        image: '',
        status: 'active'
    });

    const handleAddCategoryClose = () => {
        setAddOpen(false);
        setNewCategory({ title: '', image: '', status: 'active' });
        setImagePreview('');
    };

    const handleAddSubCategoryClose = () => {
        setAddSubOpen(false);
        setNewSubcategory({ title: '', category_id: '', image: '', status: 'active' });
        setImagePreview('');
    };

    const handleAddCategorySubmit = async () => {
        try {
           const tokenValue = sessionStorage.getItem('token');
           const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const formData = new FormData();
            formData.append('title', newCategory.title);
            formData.append('status', newCategory.status);
            if (newCategory.image) {
                formData.append('image', newCategory.image);
            }

            await postFileUpload('categories/add', formData, token);
            alert('Category added successfully!');
            handleAddCategoryClose();
        } catch (error) {
            console.error('Error adding category:', error);
            alert('Failed to add category');
        }
    };

    const handleAddSubcategorySubmit = async () => {
        try {
           const tokenValue = sessionStorage.getItem('token');
           const token = tokenValue ? `Bearer ${tokenValue}` : '';
            const formData = new FormData();
            formData.append('title', newSubcategory.title);
            formData.append('category_id', newSubcategory.category_id);
            formData.append('status', newSubcategory.status);
            if (newSubcategory.image) {
                formData.append('image', newSubcategory.image);
            }

            await postFileUpload('subcategories/add', formData, token);
            alert('Subcategory added successfully!');
            handleAddSubCategoryClose();
        } catch (error) {
            console.error('Error adding subcategory:', error);
            alert('Failed to add subcategory');
        }
    };

    const theme = useTheme();



    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        if (files.length) {
            const readers = files.map(file => {
                return new Promise(resolve => {
                    const reader = new FileReader();
                    reader.onload = ev => resolve(ev.target.result);
                    reader.readAsDataURL(file);
                });
            });
            Promise.all(readers).then(images => {
                // Preserve existing images and append new ones
                const existingImages = Array.isArray(form.product_images) ? form.product_images : [];
                const allImages = [...existingImages, ...images];
                onFormChange({
                    target: { name: 'product_images', value: allImages }
                });
            });
        }
    };

    const handleRemoveImage = (indexToRemove) => {
        const updatedImages = form.product_images.filter((_, index) => index !== indexToRemove);
        onFormChange({
            target: { name: 'product_images', value: updatedImages }
        });
    };


    const calculateSellingPrice = () => {
  const mrp = parseFloat(form.b2c_mrp) || 0;
  const discountValue = parseFloat(form.b2c_discountValue) || 0;
  
  // If there's an existing selling price and no discount is being applied, return the existing price
  if (form.b2c_sellingPrice && (!form.b2c_discountType || !form.b2c_discountValue)) {
    return form.b2c_sellingPrice;
  }
  
  if (!form.b2c_discountType || !form.b2c_mrp) {
    return mrp.toFixed(2); // Return MRP if no discount or no MRP entered
  }

  if (form.b2c_discountType === 'flat') {
    return Math.max(0, mrp - discountValue).toFixed(2);
  } 
  else if (form.b2c_discountType === 'percentage') {
    const discountAmount = mrp * (Math.min(100, discountValue) / 100);
    return Math.max(0, mrp - discountAmount).toFixed(2);
  }

  return mrp.toFixed(2);
};


    const renderStepContent = (step) => {
        switch (step) {
            case 0:
                return (
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                                <TextField
                                    fullWidth
                                    label="Title"
                                    name="title"
                                    value={form.title}
                                    onChange={onFormChange}
                                    variant="outlined"
                            required
                            sx={{width:"300px"}}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="HSN Code"
                                    name="hsn_code"
                                    value={form.hsn_code || ''}
                                    onChange={onFormChange}
                            variant="outlined"
                            sx={{width:"300px"}}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="UPC"
                                    name="upc"
                                    value={form.upc}
                                    onChange={onFormChange}
                            variant="outlined"
                            sx={{width:"300px"}}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <Box display="flex" alignItems="center" height="100%" sx={{width:"300px"}}>
                                    <Typography variant="body1" mr={2}>COD Available</Typography>
                                    <input
                                        type="checkbox"
                                        name="codAvailable"
                                        checked={!!form.codAvailable}
                                        onChange={e => onFormChange({
                                            target: {
                                                name: 'codAvailable',
                                                value: e.target.checked
                                            }
                                        })}
                                    />
                                </Box>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    fullWidth
                                    label="Brand"
                                    name="brand"
                                    value={form.brand}
                                    onChange={onFormChange}
                                    variant="outlined"
                                    sx={{width:"300px"}}
                                />
                        </Grid>
                        <Grid item xs={12} style={{width:"80%"}}>
                                <TextField
                                    fullWidth
                                    label="Description"
                                    name="description"
                                    value={form.description}
                                    onChange={onFormChange}
                                    variant="outlined"
                                    multiline
                            rows={3}
                                />
                        </Grid>
                        {/*category */}
                        <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    options={categories}
                                    getOptionLabel={(option) => option.title || ""}
                                    value={categories.find(cat => cat._id === form.category_id) || null}
                                    onChange={(event, newValue) => {
                                        onFormChange({
                                            target: {
                                                name: "category_id",
                                                value: newValue ? newValue._id : ""
                                            }
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Category"
                                            required
                                            fullWidth
                                        placeholder="Search category..."
                                        sx={{width:"300px"}}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <MenuItem 
                                            {...props} 
                                            key={option._id}
                                            style={{ height: 48 }} // Fixed menu item height
                                        >
                                            {option.title}
                                        </MenuItem>
                                    )}
                                    isOptionEqualToValue={(option, value) => option._id === value._id}
                                    ListboxProps={{
                                        style: {
                                            maxHeight: 144, // 3 items * 48px each
                                            overflow: 'auto',
                                        }
                                    }}
                                    PaperComponent={({ children }) => (
                                        <Paper style={{ 
                                            marginTop: 8,
                                            boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
                                        }}>
                                            {children}
                                        </Paper>
                                    )}
                                    noOptionsText="No categories found"
                      />
                      <Typography
                              variant="caption"
                              sx={{
                                mt: 0.5,
                                display: "block",
                                textAlign: "right",
                                color: "primary.main",
                                cursor: "pointer",
                                fontSize: '0.9rem',
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                        }}
                        onClick={() => setAddOpen(true)}
                            >
                              Add New Category
                      </Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <Autocomplete
                                    options={subcategories}
                                    getOptionLabel={(option) => option.title || ""}
                                    value={subcategories.find(sub => sub._id === form.subcategory_id) || null}
                                    onChange={(event, newValue) => {
                                        onFormChange({
                                            target: {
                                                name: "subcategory_id",
                                                value: newValue ? newValue._id : ""
                                            }
                                        });
                                    }}
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            label="Subcategory"
                                            fullWidth
                                            placeholder="Search subcategory..."
                                            InputLabelProps={{
                                                required: true // Add if you want to mark as required
                                            }}
                                            sx={{width:"300px"}}
                                        />
                                    )}
                                    renderOption={(props, option) => (
                                        <MenuItem 
                                            {...props} 
                                            key={option._id}
                                            style={{ height: 48 }} // Fixed menu item height
                                        >
                                            {option.title}
                                        </MenuItem>
                                    )}
                                    isOptionEqualToValue={(option, value) => option._id === value._id}
                                    ListboxProps={{
                                        style: {
                                            maxHeight: 144, // 3 items * 48px each
                                            overflow: 'auto',
                                        }
                                    }}
                                    PaperComponent={({ children }) => (
                                        <Paper style={{ 
                                            marginTop: 8,
                                            boxShadow: '0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12)'
                                        }}>
                                            {children}
                                        </Paper>
                                    )}
                                    noOptionsText="No subcategories found"
                      />
                      <Typography
                              variant="caption"
                              sx={{
                                mt: 0.5,
                                display: "block",
                                textAlign: "right",
                                color: "primary.main",
                                cursor: "pointer",
                                fontSize: '0.9rem',
                                "&:hover": {
                                  textDecoration: "underline",
                                },
                        }}
                        onClick={() => setAddSubOpen(true)}
                            >
                              Add New SubCategory
                      </Typography>
                        </Grid>
                    </Grid>
                );
            case 1:
                return (
                    <Grid container spacing={3}>
                        {/* Product Details fields (excluding price fields) */}
                        <Grid item xs={12} style={{ width: '90%' }}>
                                <>
                                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                                        Key Features
                                    </Typography>
                                    <Box sx={{ 
                                        border: '1px solid #ccc', 
                                        borderRadius: 1,
                                    }}>
                                        <RichTextEditor
                                            value={form.key_features || ''}
                                            onChange={(content) => {
                                                onFormChange({
                                                    target: {
                                                        name: 'key_features',
                                                        value: content
                                                    }
                                                });
                                            }}
                                            placeholder="Enter key features of the product..."
                                        />
                                    </Box>
                                </>
                        </Grid>
                        <Grid item xs={12} style={{ width: '90%' }}>
                                <>
                                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: 600 }}>
                                        How to Use
                                    </Typography>
                                    <Box sx={{ 
                                        border: '1px solid #ccc', 
                                        borderRadius: 1,
                                    }}>
                                        <RichTextEditor
                                            value={form.how_to_use || ''}
                                            onChange={(content) => {
                                                onFormChange({
                                                    target: {
                                                        name: 'how_to_use',
                                                        value: content
                                                    }
                                                });
                                            }}
                                            placeholder="Enter instructions on how to use the product..."
                                        />
                                    </Box>
                                </>
                        </Grid>
                        <Grid item xs={12} style={{ width: '90%' }}>
                                <Button variant="outlined" component="label" fullWidth
                                sx={{color:'#2B333A', borderColor:'#2B333A', 
                                '&:hover': {borderColor:'#2B333A',
                                background: 'rgba(106, 103, 92, 0.1)'
                                } }}>
                                   Upload Images and videos
                                    <input
                                        type="file"
                                        accept="image/*,video/*"
                                        hidden
                                        multiple
                                        onChange={handleImageUpload}
                                    />
                                </Button>
                        </Grid>
                        {form.product_images && form.product_images.length > 0 && (
                            <Grid item xs={12} style={{ width: '90%' }}>
                                <Typography variant="subtitle2" gutterBottom>Uploaded Media</Typography>
                                <Box display="flex" flexWrap="wrap" gap={2}>
                                    {form.product_images.map((media, idx) => {
                                        const isVideo = typeof media === 'string' && (media.startsWith('data:video') || /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(media));

                                        return (
                                        <Box
                                            key={idx}
                                            sx={{
                                                position: 'relative',
                                                display: 'inline-block'
                                            }}
                                        >
                                            {isVideo ? (
                                                <video
                                                    src={media}
                                                    controls
                                                    style={{
                                                        maxHeight: 120,
                                                        maxWidth: 200,
                                                        borderRadius: 4,
                                                        border: '1px solid #ddd'
                                                    }}
                                                />
                                            ) : (
                                                <Box
                                                    component="img"
                                                    src={media}
                                                    alt={`Product preview ${idx + 1}`}
                                                    sx={{
                                                        maxHeight: 80,
                                                        maxWidth: 80,
                                                        borderRadius: 1,
                                                        border: '1px solid #ddd'
                                                    }}
                                                />
                                            )}
                                            
                                            <IconButton
                                                size="small"
                                                onClick={() => handleRemoveImage(idx)}
                                                sx={{
                                                    position: 'absolute',
                                                    top: -8,
                                                    right: -8,
                                                    backgroundColor: 'red',
                                                    color: 'white',
                                                    '&:hover': {
                                                        backgroundColor: 'darkred'
                                                    },
                                                    width: 24,
                                                    height: 24
                                                }}
                                            >
                                                <FiTrash2 size={12} />
                                            </IconButton>
                                        </Box>
                                    );
                                    })}
                                </Box>
                            </Grid>
                        )}
                        <Grid item xs={12} sm={3}>
                                <FormControl sx={{width: '250px'}} required>
                                    <InputLabel>Unit Type</InputLabel>
                                    <Select
                                        label="Unit Type"
                                        name="unitType"
                                        value={form.unitType}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="unit">unit</MenuItem>
                                        <MenuItem value="weight">weight</MenuItem>
                                    </Select>
                                </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth
                                    label="Unit Value"
                                    name="unitValue"
                                    type="number"
                                    value={form.unitValue}
                                    onChange={onFormChange}
                                    variant="outlined"
                                    sx={{width: '250px'}}
                                />
                        </Grid>
                       
                        <Grid item xs={12} sm={3}>
                                <FormControl sx={{width: '250px'}}>
                                    <InputLabel>Unit Name</InputLabel>
                                    <Select
                                        label="Unit Name"
                                        name="unitName"
                                        value={form.unitName}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="ml">ml</MenuItem>
                                        <MenuItem value="L">L</MenuItem>
                                        <MenuItem value="g">g</MenuItem>
                                        <MenuItem value="kg">kg</MenuItem>
                                        <MenuItem value="pouch">pouch</MenuItem>
                                        <MenuItem value="packet">packet</MenuItem>
                                        <MenuItem value="sachet">sachet</MenuItem>
                                        <MenuItem value="unit">unit</MenuItem>
                                    </Select>
                                </FormControl>
                    </Grid>
                     <Grid item xs={12} sm={3}>
                                <TextField
                                    fullWidth
                                    label="Minimum Stock Quantity"
                                    name="minimumStockQuantity"
                                    type="number"
                                    value={form.minimumStockQuantity || ''}
                                    onChange={onFormChange}
                                    variant="outlined"
                                    sx={{width: '250px'}}
                                />
                        </Grid>
                    </Grid>
                );
            case 2:
                return (
                    <Grid container spacing={3}>
                        {/* Free Product Toggle */}
                        <Grid item xs={12} style={{ width: '100%' }}>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={!!form.isFree}
                                        onChange={(e) => onFormChange({
                                            target: { name: 'isFree', value: e.target.checked }
                                        })}
                                    />
                                }
                                label="Is Free Product"
                            />
                        </Grid>

                        {/* If Free, show threshold and auto add, else show B2B/B2C */}
                        {!form.isFree && (
                        <>
                        {/* B2B Price Details */}
                        <Grid item xs={12} style={{ width: '90%' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Business-to-Business (B2B) Price Details</Typography>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                                <TextField
                                    sx={{width:"250px"}}
                                    label="Selling Price (B2B)"
                                    name="b2b_sellingPrice"
                                    type="number"
                                    value={form.b2b_sellingPrice || ''}
                                    onChange={onFormChange}
                                    variant="outlined"
                                    required
                                />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                                <FormControl sx={{width:"250px"}}>
                                    <InputLabel>Discount Type (B2B)</InputLabel>
                                    <Select
                                        label="Discount Type (B2B)"
                                        name="b2b_discountType"
                                        value={form.b2b_discountType || ''}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="flat">Flat</MenuItem>
                                        <MenuItem value="percentage">Percentage</MenuItem>
                                    </Select>
                                </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4}>
                                <TextField
                                    fullWidth
                                    label="Discount Value (B2B)"
                                    name="b2b_discountValue"
                                    type="number"
                                    value={form.b2b_discountValue || ''}
                                    onChange={onFormChange}
                                    variant="outlined"
                                disabled={!form.b2b_discountType}
                                sx={{width:"250px"}}
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <FormControl sx={{width:"250px"}} required>
                                    <InputLabel>GST (%)</InputLabel>
                                    <Select
                                        label="GST (%)"
                                        name="gst"
                                        value={form.gst}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="0">0</MenuItem>
                                        <MenuItem value="5">5</MenuItem>
                                        <MenuItem value="12">12</MenuItem>
                                        <MenuItem value="18">18</MenuItem>
                                        <MenuItem value="28">28</MenuItem>
                                    </Select>
                                </FormControl>
                        </Grid>

                        {/* B2C Price Details */}
                        <Grid item xs={12} mt={4} style={{ width: '90%' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Business-to-Consumer (B2C) Price Details</Typography>
                        </Grid>
                         {/* MRP Field */}
  <Grid item xs={12} sm={4}>
        <TextField
            sx={{width:"250px"}}
            label="MRP (B2C)"
            name="b2c_mrp"
            type="number"
            value={form.b2c_mrp || ''}
            onChange={onFormChange}
            inputProps={{ min: 0 }}
            required
        />
  </Grid>
                         {/* Discount Type */}
  <Grid item xs={12} sm={4}>
        <FormControl sx={{width:"250px"}}>
            <InputLabel>Discount Type (B2C)</InputLabel>
            <Select
                label="Discount Type (B2C)"
                name="b2c_discountType"
                value={form.b2c_discountType || ''}
                onChange={onFormChange}
            >
                <MenuItem value=""><em>Select</em></MenuItem>
                <MenuItem value="flat">Flat</MenuItem>
                <MenuItem value="percentage">Percentage</MenuItem>
            </Select>
        </FormControl>
  </Grid>
                         {/* Discount Value */}
  <Grid item xs={12} sm={4}>
        <TextField
            sx={{width:"250px"}}
            label="Discount Value (B2C)"
            name="b2c_discountValue"
            type="number"
            value={form.b2c_discountValue || ''}
            onChange={onFormChange}
            inputProps={{ 
                min: 0,
                max: form.b2c_discountType === 'percentage' ? 100 : undefined
            }}
            disabled={!form.b2c_discountType}
            required={!!form.b2c_discountType}
        />
  </Grid>
                         {/* Auto-calculated Selling Price */}
  <Grid item xs={12} sm={4}>
        <TextField
            sx={{width:"250px"}}
            label="Selling Price (B2C)"
            name="b2c_sellingPrice"
            type="number"
            value={form.b2c_sellingPrice || calculateSellingPrice()}
            onChange={onFormChange}
            variant="outlined"
            required
        />
  </Grid>
                        </>
                        )}

                        {form.isFree && (
                        <>
                        <Grid item xs={12} style={{ width: '100%' }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>Free Product Settings</Typography>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    sx={{width:"250px"}}
                                    label="Threshold Amount"
                                    name="thresholdAmount"
                                    type="number"
                                    value={form.thresholdAmount || ''}
                                    onChange={onFormChange}
                                    variant="outlined"
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={!!form.autoAdd}
                                            onChange={(e) => onFormChange({
                                                target: { name: 'autoAdd', value: e.target.checked }
                                            })}
                                        />
                                    }
                                    label="Auto Add to Cart"
                                />
                        </Grid>
                         <Grid item xs={12} sm={6}>
                                <FormControl sx={{width:"250px"}} required>
                                    <InputLabel>GST (%)</InputLabel>
                                    <Select
                                        label="GST (%)"
                                        name="gst"
                                        value={form.gst}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="0">0</MenuItem>
                                        <MenuItem value="5">5</MenuItem>
                                        <MenuItem value="18">18</MenuItem>
                                    </Select>
                                </FormControl>
                        </Grid>
                        </>
                        )}
                    </Grid>
                );
            case 3:
                return (
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                                <Box>
                                     <Typography variant="subtitle1" gutterBottom>Product Dimensions</Typography>
                                     <Grid container spacing={2}>
                                         <Grid item xs={12} sm={3}>
                                             <TextField
                                                 sx={{width:"250px"}}
                                                 label="Length"
                                                 name="length"
                                                 type="number"
                                                 value={form.length || ''}
                                                 onChange={onFormChange}
                                                 variant="outlined"
                                                 inputProps={{ min: 0, step: "0.01" }}
                                             />
                                         </Grid>
                                         <Grid item xs={12} sm={3}>
                                             <TextField
                                                 sx={{width:"250px"}}
                                                 label="Width"
                                                 name="width"
                                                 type="number"
                                                 value={form.width || ''}
                                                 onChange={onFormChange}
                                                 variant="outlined"
                                                 inputProps={{ min: 0, step: "0.01" }}
                                             />
                                         </Grid>
                                         <Grid item xs={12} sm={3}>
                                             <TextField
                                                 sx={{width:"250px"}}
                                                 label="Height"
                                                 name="height"
                                                 type="number"
                                                 value={form.height || ''}
                                                 onChange={onFormChange}
                                                 variant="outlined"
                                                 inputProps={{ min: 0, step: "0.01" }}
                                             />
                                         </Grid>
                                         <Grid item xs={12} sm={3}>
                                             <FormControl sx={{width:"250px"}}>
                                                 <InputLabel>Dimension Unit</InputLabel>
                                                 <Select
                                                     label="Dimension Unit"
                                                     name="dimensionUnit"
                                                     value={form.dimensionUnit || ''}
                                                     onChange={onFormChange}
                                                 >
                                                     <MenuItem value=""><em>Select</em></MenuItem>
                                                     <MenuItem value="cm">Centimeters (cm)</MenuItem>
                                                     <MenuItem value="mm">Millimeters (mm)</MenuItem>
                                                     <MenuItem value="in">Inches (in)</MenuItem>
                                                     <MenuItem value="m">Meters (m)</MenuItem>
                                                 </Select>
                                             </FormControl>
                                         </Grid>
                                         <Grid item xs={12} sm={3}>
                                             <TextField
                                                 sx={{width:"250px"}}
                                                 label="Weight"
                                                 name="weight"
                                                 type="number"
                                                 value={form.weight || ''}
                                                 onChange={onFormChange}
                                                 variant="outlined"
                                                 inputProps={{ min: 0, step: "0.01" }}
                                             />
                                         </Grid>
                                         <Grid item xs={12} sm={3}>
                                             <FormControl sx={{width:"250px"}}>
                                                 <InputLabel>Weight Unit</InputLabel>
                                                 <Select
                                                     label="Weight Unit"
                                                     name="weightUnit"
                                                     value={form.weightUnit || ''}
                                                     onChange={onFormChange}
                                                 >
                                                     <MenuItem value=""><em>Select</em></MenuItem>
                                                     <MenuItem value="g">Grams (g)</MenuItem>
                                                     <MenuItem value="kg">Kilograms (kg)</MenuItem>
                                                     <MenuItem value="mg">Milligrams (mg)</MenuItem>
                                                     <MenuItem value="lb">Pounds (lb)</MenuItem>
                                                 </Select>
                                             </FormControl>
                                         </Grid>
                                     </Grid>
                                 </Box>
                        </Grid>
                    </Grid>
                );
            case 4:
                return (
                    <Grid container spacing={3}>
                        {/* <Grid item xs={12} sm={6}>
                            {formMode === 'view' ? (
                                renderViewField('Status', form.status || 'Not selected')
                            ) : (
                                <FormControl fullWidth>
                                    <InputLabel>Status</InputLabel>
                                    <Select
                                        label="Status"
                                        name="status"
                                        value={form.status}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="approved">approved</MenuItem>
                                        <MenuItem value="pending">pending</MenuItem>
                                        <MenuItem value="rejected">rejected</MenuItem>
                                    </Select>
                                </FormControl>
                            )}
                        </Grid> */}
                        
                        <Grid item xs={12} sm={6}>
                                <FormControl sx={{width:"250px"}}>
                                    <InputLabel>Ideal For</InputLabel>
                                    <Select
                                        label="Ideal For"
                                        name="ideal_for"
                                        value={form.ideal_for}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="men">men</MenuItem>
                                        <MenuItem value="women">women</MenuItem>
                                        <MenuItem value="unisex">unisex</MenuItem>
                                    </Select>
                                </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    sx={{width:"250px"}}
                                    label="Applied For"
                                    name="applied_for"
                                    value={form.applied_for}
                                    onChange={onFormChange}
                                    variant="outlined"
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <FormControl sx={{width:"250px"}}>
                                    <InputLabel>Container Type</InputLabel>
                                    <Select
                                        label="Container Type"
                                        name="container_type"
                                        value={form.container_type}
                                        onChange={onFormChange}
                                    >
                                        <MenuItem value=""><em>Select</em></MenuItem>
                                        <MenuItem value="bottle">bottle</MenuItem>
                                        <MenuItem value="box">box</MenuItem>
                                        <MenuItem value="packet">packet</MenuItem>
                                        <MenuItem value="can">can</MenuItem>
                                        <MenuItem value="jar">jar</MenuItem>
                                        <MenuItem value="bag">bag</MenuItem>
                                        <MenuItem value="pouch">pouch</MenuItem>
                                        <MenuItem value="tube">tube</MenuItem>
                                        <MenuItem value="roll">roll</MenuItem>
                                        <MenuItem value="crate">crate</MenuItem>
                                        <MenuItem value="sachet">sachet</MenuItem>
                                        <MenuItem value="drum">drum</MenuItem>
                                        <MenuItem value="blister_pack">blister_pack</MenuItem>
                                        <MenuItem value="strip">strip</MenuItem>
                                        <MenuItem value="unit">unit</MenuItem>
                                    </Select>
                                </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    sx={{width:"250px"}}
                                    label="Country of Origin"
                                    name="country_of_orgin"
                                    value={form.country_of_orgin}
                                    onChange={onFormChange}
                                    variant="outlined"
                                />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                                <TextField
                                    sx={{width:"250px"}}
                                    label="Color"
                                    name="color"
                                    value={form.color}
                                    onChange={onFormChange}
                                    variant="outlined"
                                />
                        </Grid>
                        {/* Tags - multi entry */}
                        <Grid item xs={12} style={{width:"90%"}}>
                                <Autocomplete
                                    multiple
                                    freeSolo
                                    options={[]}
                                    value={Array.isArray(form.tags) ? form.tags : []}
                                    onChange={(event, newValue) => {
                                        onFormChange({ target: { name: 'tags', value: newValue } });
                                    }}
                                    renderTags={(value, getTagProps) =>
                                        value.map((option, index) => (
                                            <Chip variant="outlined" label={option} {...getTagProps({ index })} />
                                        ))
                                    }
                                    renderInput={(params) => (
                                        <TextField
                                            {...params}
                                            variant="outlined"
                                            label="Tags"
                                            placeholder="Type and press Enter"
                                            fullWidth
                                        />
                                    )}
                                />
                        </Grid>
                       
                    </Grid>
                );
            case 5:
                return (
               <Box sx={{ 
                p: 1.5, 
                background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
                borderRadius: 3,
                position: 'relative',
                overflow: 'hidden',
              }}>
                {/* Decorative Elements */}
                <Box sx={{
                  position: 'absolute',
                  top: -50,
                  right: -50,
                  width: 100,
                  height: 100,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #667eea 0%, #764ba2 50%)',
                  opacity: 0.1,
                  
                }} />
                
                <Box sx={{
                  position: 'absolute',
                  bottom: -30,
                  left: -30,
                  width: 80,
                  height: 80,
                  borderRadius: '50%',
                  background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 50%)',
                  opacity: 0.1
                }} />

                {/* Header */}
                <Box sx={{ 
                  display: 'flex', 
                  justifyContent: 'space-between', 
                  alignItems: 'center',
                  mb: 4,
                  position: 'relative',
                  zIndex: 2
                }}>
                  <Box>
                    <Typography variant="h4" sx={{ 
                      fontWeight: 700, 
                      background: 'black',
                      backgroundClip: 'text',
                      WebkitBackgroundClip: 'text',
                      WebkitTextFillColor: 'transparent',
                      mb: 1
                    }}>
                      Product Review
                    </Typography>
                  </Box>
                  
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  {/* Top Section - Product Gallery with Left-Right Layout */}
                  <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Paper
                      elevation={0}
                      sx={{
                        p: 3,
                        borderRadius: 4,
                        background: 'rgba(255, 255, 255, 0.9)',
                        backdropFilter: 'blur(10px)',
                        border: '1px solid rgba(255, 255, 255, 0.2)',
                        overflow: 'hidden',
                        maxWidth: 1400,
                        width: '100%'
                      }}
                    >
                      
                      
                      {form.product_images?.length > 0 ? (
                        <Box sx={{ display: 'flex', gap: 4, alignItems: 'flex-start' }}>
                          {/* Left Side - Main Image */}
                          <Box sx={{ flex: '0 0 34%',maxWidth: '34%'  }}>
                            <Paper
                              elevation={0}
                              sx={{
                                position: 'relative',
                                borderRadius: 3,
                                overflow: 'hidden',
                                aspectRatio: '1/1',
                                bgcolor: 'grey.50',
                                border: '1px solid',
                                borderColor: 'divider',
                                width:"400px",
                                height:"400px"
                              }}
                            >
                                {(() => {
                                    const media = form.product_images[activeImageIndex];
                                    const isVideo = typeof media === 'string' && (media.startsWith('data:video') || /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(media));
                                    return isVideo ? (
                                        <video
                                            src={media}
                                            controls
                                            style={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'contain',
                                                backgroundColor: '#000'
                                            }}
                                        />
                                    ) : (
                                        <Box
                                            component="img"
                                            src={media}
                                            alt={`Product View ${activeImageIndex + 1}`}
                                            sx={{
                                                width: '100%',
                                                height: '100%',
                                                objectFit: 'cover',
                                                transition: 'transform 0.3s ease',
                                                '&:hover': {
                                                    transform: 'scale(1.05)'
                                                }
                                            }}
                                        />
                                    );
                                })()}
                              <Chip
                                label={`${activeImageIndex + 1} / ${form.product_images.length}`}
                                size="small"
                                sx={{
                                  position: 'absolute',
                                  top: 16,
                                  right: 16,
                                  bgcolor: 'rgba(0,0,0,0.7)',
                                  color: 'white',
                                  fontWeight: 600
                                }}
                              />
                              
                              {/* Navigation Arrows */}
                              <IconButton
                                onClick={() => setActiveImageIndex(prev => prev > 0 ? prev - 1 : form.product_images.length - 1)}
                                sx={{
                                  position: 'absolute',
                                  left: 8,
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  bgcolor: 'rgba(255,255,255,0.9)',
                                  '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
                                }}
                              >
                                <MdChevronLeft size={20} />
                              </IconButton>
                              <IconButton
                                onClick={() => setActiveImageIndex(prev => prev < form.product_images.length - 1 ? prev + 1 : 0)}
                                sx={{
                                  position: 'absolute',
                                  right: 8,
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  bgcolor: 'rgba(255,255,255,0.9)',
                                  '&:hover': { bgcolor: 'rgba(255,255,255,1)' }
                                }}
                              >
                                <MdChevronRight size={20} />
                              </IconButton>
                            </Paper>
                          </Box>
                          
                          {/* Right Side - Product Title, Price & Thumbnails */}
                          <Box   sx={{
                                    flex: '0 0 65%',   // 👈 70%
                                    maxWidth: '65%',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 3
                                  }}>
                                              {/* Product Title & Price */}
                                              
                                    <Paper
                                      elevation={0}
                                      sx={{
                                        p: 3,
                                        borderRadius: 3,
                                        background: 'rgba(255, 255, 255, 0.8)',
                                        backdropFilter: 'blur(10px)',
                                        border: '1px solid rgba(255, 255, 255, 0.2)'
                                      }}
                                    >
                                      {/* Title and Price in a row */}
                                      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', mb: 2 }}>
                                        <Typography variant="h5" sx={{ fontWeight: 700, color: 'text.primary' }}>
                                          {form.title || 'Product Title Not Provided'}
                                        </Typography>
                                        
                                        {/* Price section */}
                                        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
                                          <Chip
                                          icon={form.isPublished ? <MdVisibility size={18} /> : <MdVisibilityOff size={18} />}
                                          label={form.isPublished ? 'Published' : 'Draft'}
                                          color={form.isPublished ? 'success' : 'warning'}
                                          sx={{
                                            fontWeight: 600,
                                            px: 2,
                                            py: 1,
                                            height: 40,
                                            fontSize: '0.875rem',
                                            boxShadow: 2
                                          }}
                                        />
                                          
                                        </Box>
                                      </Box>
                                      
                                      {/* Category and subCategory chips */}
                                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 0 }}>
                                        <Chip
                                          icon={<MdCategory size={16} />}
                                          label={categories.find(cat => cat._id === form.category_id)?.title || 'No Category'}
                                          variant="outlined"
                                          color="primary"
                                          sx={{ fontWeight: 500 }}
                                        />
                                        <Chip
                                          icon={<MdCategory size={16} />}
                                          label={subcategories.find(sub => sub._id === form.subcategory_id)?.title || 'No Subcategory'}
                                          variant="outlined"
                                          color="secondary"
                                          sx={{ fontWeight: 500 }}
                                        />
                                      </Box>
                                    </Paper>
                            
                            {/* Thumbnail Strip */}
                            <Paper
                              elevation={0}
                              sx={{
                                p: 2,
                                borderRadius: 3,
                                background: 'rgba(255, 255, 255, 0.8)',
                                backdropFilter: 'blur(10px)',
                                border: '1px solid rgba(255, 255, 255, 0.2)'
                              }}
                            >
                              <Typography variant="body2" sx={{ fontWeight: 600, mb: 2, color: 'text.secondary' }}>
                                Product Images ({form.product_images.length})
                              </Typography>
                              <Box sx={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                                {/* <IconButton 
                                    onClick={scrollLeft}
                                    sx={{ 
                                        position: 'absolute', 
                                        left: -10, 
                                        zIndex: 2,
                                        bgcolor: 'rgba(255,255,255,0.8)',
                                        '&:hover': { bgcolor: 'white' },
                                        boxShadow: 1
                                    }}
                                    size="small"
                                >
                                    <MdChevronLeft />
                                </IconButton> */}
                                <Box 
                                    ref={scrollContainerRef}
                                    sx={{ 
                                        display: 'flex', 
                                        gap: 1, 
                                        overflowX: 'auto', 
                                        pb: 1,
                                        px: 3, // padding for buttons
                                        scrollbarWidth: 'none', // hide scrollbar for cleaner look
                                        '&::-webkit-scrollbar': { display: 'none' },
                                        scrollBehavior: 'smooth'
                                    }}
                                >
                                {form.product_images.map((img, idx) => (
                                  <Paper
                                    key={idx}
                                    elevation={0}
                                    onClick={() => setActiveImageIndex(idx)}
                                    sx={{
                                      width: 120,
                                      height: 120,
                                      flexShrink: 0,
                                      borderRadius: 2,
                                      overflow: 'hidden',
                                      cursor: 'pointer',
                                      border: 2,
                                      borderColor: activeImageIndex === idx ? 'primary.main' : 'transparent',
                                      transition: 'all 0.2s',
                                    }}
                                  >
                                    {(() => {
                                        const isVideo = typeof img === 'string' && (img.startsWith('data:video') || /\.(mp4|webm|ogg|mov|avi|mkv)$/i.test(img));
                                        return isVideo ? (
                                            <video
                                                src={img}
                                                style={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        ) : (
                                            <Box
                                                component="img"
                                                src={img}
                                                alt={`Thumbnail ${idx + 1}`}
                                                sx={{
                                                    width: '100%',
                                                    height: '100%',
                                                    objectFit: 'cover'
                                                }}
                                            />
                                        );
                                    })()}
                                  </Paper>
                                ))}
                                </Box>
                                {/* <IconButton 
                                    onClick={scrollRight}
                                    sx={{ 
                                        position: 'absolute', 
                                        right: -10, 
                                        zIndex: 2,
                                        bgcolor: 'rgba(255,255,255,0.8)',
                                        '&:hover': { bgcolor: 'white' },
                                        boxShadow: 1
                                    }}
                                    size="small"
                                >
                                    <MdChevronRight />
                                </IconButton> */}
                              </Box>
                            </Paper>
                          </Box>
                        </Box>
                      ) : (
                        <Paper
                          elevation={0}
                          sx={{
                            aspectRatio: '1/1',
                            borderRadius: 3,
                            bgcolor: 'grey.100',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            border: '2px dashed',
                            borderColor: 'divider'
                          }}
                        >
                          <Box sx={{ textAlign: 'center', color: 'text.secondary' }}>
                            <MdImage size={48} style={{ marginBottom: 8, opacity: 0.5 }} />
                            <Typography variant="body2">No images uploaded</Typography>
                          </Box>
                        </Paper>
                      )}
                    </Paper>
                  </Box>

                  {/* Bottom Section - Product Details */}
                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
                  

                    {/* Information Cards */}
                    <Grid container spacing={3}>
                      {/* Basic Information */}
                      {/* <Grid item xs={12}> */}
                        <Paper
                          elevation={0}
                          sx={{
                            p: 4,
                            borderRadius: 4,
                            background: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            width: '100%',
                            maxWidth: 1400
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                            <Avatar sx={{ bgcolor: 'info.main', width: 32, height: 32 }}>
                              <MdInfo size={18} color="white" />
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                              Basic Information
                            </Typography>
                          </Box>
                          
                          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(4, 1fr)' }, gap: 3 }}>
                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.primary.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                                // transition: 'transform 0.2s ease',
                                // '&:hover': { transform: 'translateY(-2px)' },
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdLocalOffer size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    UPC Code
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.upc || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                              </Paper>
                              

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.success.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                                // transition: 'transform 0.2s ease',
                                // '&:hover': { transform: 'translateY(-2px)' },
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'success.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdScale size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Unit
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.unitValue} {form.unitName}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.secondary.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                                // transition: 'transform 0.2s ease',
                                // '&:hover': { transform: 'translateY(-2px)' },
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'secondary.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdLocalOffer size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    HSN Code
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.hsn_code  || 'No HSN Code'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.warning.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
                                // transition: 'transform 0.2s ease',
                                // '&:hover': { transform: 'translateY(-2px)' },
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'warning.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdSchedule size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Status
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.status || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>
                          </Box>
                        </Paper>
                      {/* </Grid> */}

                      {/* Price Information */}
                      {/* <Grid item xs={12}> */}
                        <Paper
                          elevation={0}
                          sx={{
                            p: 4,
                            borderRadius: 4,
                            background: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            width: '100%',
                            maxWidth: 1400
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                            <Avatar sx={{ bgcolor: 'success.main', width: 32, height: 32 }}>
                              <MdCurrencyRupee size={18} color="white" />
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                              Price Information
                            </Typography>
                          </Box>
                          
                          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' }, gap: 3 }}>
                            {/* If not free, show B2B and B2C cards */}
                            {!form.isFree && (
                            <>
                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.primary.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                                // transition: 'transform 0.2s ease',
                                // '&:hover': { transform: 'translateY(-2px)' }
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                                  <MdShoppingBag size={20} color="white" />
                                </Avatar>
                                <Box>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
                                    B2B Price
                                  </Typography>
                                  <Typography variant="h6" sx={{ fontWeight: 700, color: 'primary.main' }}>
                                    ₹{form.b2b_sellingPrice || 'Not set'}
                                  </Typography>
                                </Box>
                              </Box>
                              {form.b2b_discountType && form.b2b_discountValue && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Chip
                                    label={`${form.b2b_discountValue}${form.b2b_discountType === 'percentage' ? '% OFF' : ' ₹ OFF'}`}
                                    color="primary"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                </Box>
                              )}
                            </Paper>

                            {/* B2C Price */}
                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.success.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                                // transition: 'transform 0.2s ease',
                                // '&:hover': { transform: 'translateY(-2px)' }
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                <Avatar sx={{ bgcolor: 'success.main', width: 40, height: 40 }}>
                                  <MdCurrencyRupee size={20} color="white" />
                                </Avatar>
                                <Box>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
                                    B2C Price
                                  </Typography>
                                  <Typography variant="h6" sx={{ fontWeight: 700, color: 'success.main' }}>
                                    ₹{form.b2c_sellingPrice || form.b2c_mrp || 'Not set'}
                                  </Typography>
                                </Box>
                              </Box>
                              {form.b2c_mrp && (
                                <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                                  MRP: ₹{form.b2c_mrp}
                                </Typography>
                              )}
                              {form.b2c_discountType && form.b2c_discountValue && (
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                  <Chip
                                    label={`${form.b2c_discountValue}${form.b2c_discountType === 'percentage' ? '% OFF' : ' ₹ OFF'}`}
                                    color="success"
                                    size="small"
                                    sx={{ fontWeight: 600 }}
                                  />
                                </Box>
                              )}
                            </Paper>
                            </>
                            )}

                            {/* If free, show Threshold and Auto Add */}
                            {form.isFree && (
                            <>
                              <Paper
                                elevation={0}
                                sx={{
                                  p: 3,
                                  borderRadius: 3,
                                  background: alpha(theme.palette.info.main, 0.08),
                                  border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                  <Avatar sx={{ bgcolor: 'info.main', width: 40, height: 40 }}>
                                    <MdCurrencyRupee size={20} color="white" />
                                  </Avatar>
                                  <Box>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
                                      Threshold Amount
                                    </Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: 'info.main' }}>
                                      {form.thresholdAmount ? `₹${form.thresholdAmount}` : 'Not set'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Paper>

                              <Paper
                                elevation={0}
                                sx={{
                                  p: 3,
                                  borderRadius: 3,
                                  background: alpha(theme.palette.warning.main, 0.08),
                                  border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
                                }}
                              >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                                  <Avatar sx={{ bgcolor: 'warning.main', width: 40, height: 40 }}>
                                    <MdShoppingBag size={20} color="white" />
                                  </Avatar>
                                  <Box>
                                    <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase' }}>
                                      Auto Add to Cart
                                    </Typography>
                                    <Typography variant="h6" sx={{ fontWeight: 700, color: 'warning.main' }}>
                                      {form.autoAdd ? 'Yes' : 'No'}
                                    </Typography>
                                  </Box>
                                </Box>
                              </Paper>
                            </>
                            )}
                          </Box>
                        </Paper>
                      {/* </Grid> */}



                       {/* Product Description */}
                        <Paper
                          elevation={2}
                          sx={{
                            p: 3.5,
                            borderRadius: 3,
                            mb: 3,
                            background: 'white',
                            boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                            width: '100%',
                            maxWidth: 1400
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                            <Avatar sx={{ bgcolor: 'info.main', width: 40, height: 40 }}>
                              <MdInfo size={20} color="white" />
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
                              Description
                            </Typography>
                          </Box>
                          <Typography variant="body1" sx={{ 
                            lineHeight: 1.7,
                            color: 'text.primary',
                            p: 2,
                            borderRadius: 2,
                            background: alpha(theme.palette.info.main, 0.05),
                            border: `1px solid ${alpha(theme.palette.info.main, 0.15)}`
                          }}>
                            {form.description || 'No description provided'}
                          </Typography>
                        </Paper>

                      {/* Product Details */}
                      {/* <Grid item xs={12}> */}
                        <Paper
                          elevation={0}
                          sx={{
                            p: 4,
                            borderRadius: 4,
                            background: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(10px)',
                            border: '1px solid rgba(255, 255, 255, 0.2)',
                            width: '100%',
                            maxWidth: 1400,
                          }}
                        >
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 3 }}>
                            <Avatar sx={{ bgcolor: 'secondary.main', width: 32, height: 32 }}>
                              <MdCategory size={18} color="white" />
                            </Avatar>
                            <Typography variant="h6" sx={{ fontWeight: 700 }}>
                              Product Details
                            </Typography>
                          </Box>
                          
                          <Box sx={{ display: 'grid', gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)', md: 'repeat(3, 1fr)' }, gap: 3 }}>
                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.secondary.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.secondary.main, 0.2)}`,
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'secondary.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdLocalOffer size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Brand
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.brand || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.warning.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.warning.main, 0.2)}`,
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'warning.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdStar size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Ideal For
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.ideal_for || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.error.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.error.main, 0.2)}`,
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'error.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdSchedule size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Applied For
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.applied_for || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.info.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.info.main, 0.2)}`,
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'info.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdScale size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Container Type
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.container_type || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.success.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.success.main, 0.2)}`,
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'success.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdCategory size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Country of Origin
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.country_of_orgin || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>

                            <Paper
                              elevation={0}
                              sx={{
                                p: 3,
                                borderRadius: 3,
                                background: alpha(theme.palette.primary.main, 0.08),
                                border: `1px solid ${alpha(theme.palette.primary.main, 0.2)}`,
                                height: 120,
                                display: 'flex',
                                alignItems: 'center'
                              }}
                            >
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                <Avatar sx={{ bgcolor: 'primary.main', width: 48, height: 48, flexShrink: 0 }}>
                                  <MdLocalOffer size={24} color="white" />
                                </Avatar>
                                <Box sx={{ flex: 1, minWidth: 0 }}>
                                  <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 600, textTransform: 'uppercase', display: 'block', mb: 0.5 }}>
                                    Color
                                  </Typography>
                                  <Typography variant="body2" sx={{ fontWeight: 600, wordBreak: 'break-word', lineHeight: 1.2 }}>
                                    {form.color || 'Not provided'}
                                  </Typography>
                                </Box>
                              </Box>
                            </Paper>
                          </Box>
                        </Paper>
                      {/* </Grid> */}

                    

                     {/* Key Features */}
                        {form.key_features && (
                          <Paper
                            elevation={2}
                            sx={{
                              p: 3.5,
                              borderRadius: 3,
                              mb: 3,
                              background: 'white',
                              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                              width: '100%',
                              maxWidth: 1400,
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                              <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40 }}>
                                <MdStar size={20} color="white" />
                              </Avatar>
                              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
                                Key Features
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                p: 2.5,
                                borderRadius: 2,
                                background: alpha(theme.palette.primary.main, 0.05),
                                border: `1px solid ${alpha(theme.palette.primary.main, 0.15)}`
                              }}
                              dangerouslySetInnerHTML={{ __html: form.key_features }}
                            />
                          </Paper>
                        )}

                      {/* How to Use */}
                        {form.how_to_use && (
                          <Paper
                            elevation={2}
                            sx={{
                              p: 3.5,
                              borderRadius: 3,
                              background: 'white',
                              boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
                              width: '100%',
                              maxWidth: 1400,
                            }}
                          >
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2.5 }}>
                              <Avatar sx={{ bgcolor: 'success.main', width: 40, height: 40 }}>
                                <MdInfo size={20} color="white" />
                              </Avatar>
                              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
                                How to Use
                              </Typography>
                            </Box>
                            <Box
                              sx={{
                                p: 2.5,
                                borderRadius: 2,
                                background: alpha(theme.palette.success.main, 0.05),
                                border: `1px solid ${alpha(theme.palette.success.main, 0.15)}`
                              }}
                              dangerouslySetInnerHTML={{ __html: form.how_to_use }}
                            />
                          </Paper>
                        )}

                    
                    </Grid>

                    {/* Quick Stats */}
                    <Grid container spacing={3}>
                      <Grid item xs={6} sm={3}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 3,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            color: 'white',
                            textAlign: 'center',
                            // transition: 'transform 0.2s ease',
                            // '&:hover': { transform: 'translateY(-4px)' }
                          }}
                        >
                          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                            {form.product_images?.length || 0}
                          </Typography>
                          <Typography variant="body2" sx={{ opacity: 0.9 }}>
                            Images
                          </Typography>
                        </Paper>
                      </Grid>
                      
                      <Grid item xs={6} sm={3}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 3,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
                            color: 'white',
                            textAlign: 'center',
                            // transition: 'transform 0.2s ease',
                            // '&:hover': { transform: 'translateY(-4px)' }
                          }}
                        >
                          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                            {form.isPublished ? '✓' : '✗'}
                          </Typography>
                          <Typography variant="body2" sx={{ opacity: 0.9 }}>
                            Published
                          </Typography>
                        </Paper>
                      </Grid>
                      
                      <Grid item xs={6} sm={3}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 3,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
                            color: 'white',
                            textAlign: 'center',
                            // transition: 'transform 0.2s ease',
                            // '&:hover': { transform: 'translateY(-4px)' }
                          }}
                        >
                          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                            {form.b2c_discountValue || 0}{form.b2c_discountType === 'percentage' ? '%' : '₹'}
                          </Typography>
                          <Typography variant="body2" sx={{ opacity: 0.9 }}>
                            Discount
                          </Typography>
                        </Paper>
                      </Grid>
                      
                      <Grid item xs={6} sm={3}>
                        <Paper
                          elevation={0}
                          sx={{
                            p: 3,
                            borderRadius: 4,
                            background: 'linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)',
                            color: 'white',
                            textAlign: 'center',
                            // transition: 'transform 0.2s ease',
                            // '&:hover': { transform: 'translateY(-4px)' }
                          }}
                        >
                          <Typography variant="h4" sx={{ fontWeight: 700, mb: 1 }}>
                          <MdScale size={25} color="white" />{form.minimumStockQuantity || 'Not set'}
                          </Typography>
                          <Typography variant="body2" sx={{ opacity: 0.9 }}>
                            Minimum Stock Quantity
                          </Typography>
                        </Paper>
                      </Grid>
                    </Grid>
                  </Box>
                </Box>
              </Box>
                );
            default:
                return 'Unknown step';
        }
    };

    return (
        <Box sx={{ fontFamily: 'Mulish, sans-serif' }}>
            

            <Box p={2} component={Paper} boxShadow={'none'} sx={{boxShadow: '0 4px 20px rgba(0,0,0,0.08)',borderRadius: '12px'}}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" fontWeight="bold" sx={{ fontFamily:'Mulish, sans-serif',}}>
                    {isEdit ? 'Edit Product' : (activeStep === steps.length - 1 ? 'Review Product' : 'Add New Product')}
                </Typography>

                <Box sx={{ fontFamily: 'Mulish, sans-serif',gap: 1 }} >

                <Button
                variant="contained"
                onClick={onCancel}
                sx={{ mb: 2, color: "white", background: 'red',
                  '&:hover': {
                                        bgcolor: 'red'
                                        } 
                }}
            >
                Back
            </Button>
            </Box>
            </Box>
                <Typography variant="body2" color="text.secondary" mb={2} sx={{ fontFamily:'Mulish, sans-serif',}}>
                    {activeStep === steps.length - 1 ?
                        'Review all details before submitting' :
                        `${steps[activeStep]}`}
                </Typography>



                <Box pt={2} display="flex">
                    {/* Vertical Stepper on the left - Hidden on review page */}
                    {activeStep < steps.length - 1 && (
                        <Box sx={{ width: 200, mr: 4 }}>
                            <Stepper
                                activeStep={activeStep}
                                orientation="vertical"
                                sx={{
                                    '& .MuiStepLabel-root': {
                                        alignItems: 'flex-start'
                                    },
                                    '& .MuiStepConnector-root': {
                                        ml: 1.5
                                    },
                                    '& .MuiStepConnector-line': {
                                        minHeight: 24
                                    },
                                    '& .MuiStepIcon-root': {
                                        color: '#2B333A !important', // step icon color
                                    },
                                    '& .Mui-completed .MuiStepIcon-root': {
                                        color: 'grey !important',
                                    },

                                }}
                            >
                                {steps.map((label, index) => (
                                    <Step key={label}>
                                        <StepLabel
                                            sx={{
                                                fontFamily:'Mulish, sans-serif',
                                                '& .MuiStepLabel-label': {
                                                    textAlign: 'left',
                                                    mt: 0.5
                                                }
                                            }}
                                        >
                                            {label}
                                        </StepLabel>
                                    </Step>
                                ))}
                            </Stepper>
                        </Box>
                    )}

                    {/* Form content - Full width on review page */}
                    <Box flex={1}>
                        {renderStepContent(activeStep)}

                        {/* <Divider  /> */}

                        <Box display="flex" justifyContent="space-between" sx={{ my: 2 }}>
                            <Button
                                onClick={activeStep === 0 ? onCancel : handleBack}
                                variant="contained"
                                style={{
                                    color: 'white',
                                    background: 'red'
                                }}
                            >
                                {activeStep === 0 ? 'Cancel' : 'Back'}
                            </Button>

                            <Box>
                                {activeStep < steps.length - 1 ? (
                                    
                                        <Button
                                            onClick={handleNext}
                                            variant="contained"
                                            // color="primary"
                                            style={{ background: "#2B333A", color: 'white' }}
                                        >
                                            Next
                                        </Button>
                                
                                ) : (
                                (
                                    <Button
                                        onClick={onSubmit}
                                        variant="contained"
                                        // disabled={isSubmitDisabled}
                                        style={{ color: 'white', background: '#2B333A' }}

                                    >
                                        {isEdit ? 'Update Product' : 'Submit Product'}
                                    </Button>
                                )
                                )}
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            {/* Add Category Modal */}
            <Dialog
                open={addOpen}
                onClose={handleAddCategoryClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                sx: {
                    borderRadius: '12px',
                    boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                }
                }}
            >
                <DialogTitle
                sx={{
                    fontSize: '1.25rem',
                    fontWeight: 600,
                    py: 2,
                    px: 3,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                }}
                >
                Add New Category
                <IconButton
                    onClick={handleAddCategoryClose}
                    sx={{
                    color: 'text.secondary',
                    '&:hover': {
                        backgroundColor: 'rgba(0,0,0,0.05)'
                    }
                    }}
                >
                    <FiX size={20} />
                </IconButton>
                </DialogTitle>

                <DialogContent sx={{ py: 3, px: 3 }}>
                <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 3, marginTop: '10PX' }}>
                    {/* Title Field */}
                    <TextField
                    variant="outlined"
                    label="Category Name"
                    value={newCategory.title}
                    onChange={e => setNewCategory({ ...newCategory, title: e.target.value })}
                    fullWidth
                    InputProps={{
                        startAdornment: (
                        <InputAdornment position="start">
                            <FiType color="#6c757d" size={18} />
                        </InputAdornment>
                        ),
                        sx: {
                        borderRadius: '8px',
                        '& input': {
                            py: 1.5
                        }
                        }
                    }}
                    />

                    {/* Image Upload */}
                    <Box>
                    <Typography variant="subtitle2" sx={{
                        mb: 1,
                        fontWeight: 500,
                        color: 'text.secondary',
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <FiUploadCloud size={16} />
                        Category Image
                    </Typography>

                    <Box
                        component="label"
                        htmlFor="category-image-upload"
                        sx={{
                        border: '2px dashed',
                        borderColor: 'divider',
                        borderRadius: 2,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 3,
                        textAlign: 'center',
                        cursor: 'pointer',
                        transition: 'all 0.3s ease',
                        '&:hover': {
                            borderColor: 'primary.main',
                            backgroundColor: 'rgba(0, 123, 255, 0.05)'
                        }
                        }}
                    >
                        {imagePreview ? (
                        <Box sx={{ position: 'relative', width: '100%' }}>
                            <img
                            src={imagePreview}
                            alt="Preview"
                            style={{
                                width: '100%',
                                maxHeight: 200,
                                objectFit: 'contain',
                                borderRadius: 6
                            }}
                            />
                            <IconButton
                            sx={{
                                position: 'absolute',
                                top: 8,
                                right: 8,
                                backgroundColor: 'rgba(0,0,0,0.5)',
                                color: 'white',
                                '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.7)'
                                }
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setImagePreview('');
                                setNewCategory({ ...newCategory, image: '' });
                            }}
                            >
                            <FiTrash2 size={16} />
                            </IconButton>
                        </Box>
                        ) : (
                        <>
                            <FiUploadCloud size={48} color="#adb5bd" style={{ marginBottom: '8px' }} />
                            <Typography variant="body2" sx={{ mb: 1 }}>
                            <Box component="span" sx={{ color: 'primary.main', fontWeight: 500 }}>
                                Click to upload
                            </Box> or drag and drop
                            </Typography>
                            <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                            PNG, JPG, GIF (Max 2MB)
                            </Typography>
                        </>
                        )}

                        <input
                        id="category-image-upload"
                        type="file"
                        accept="image/*"
                        hidden
                        onChange={e => {
                            const file = e.target.files[0];
                            if (file) {
                            setNewCategory({ ...newCategory, image: file });
                            setImagePreview(URL.createObjectURL(file));
                            }
                        }}
                        />
                    </Box>
                    </Box>

                    {/* Status Selector */}
                    <FormControl fullWidth>
                    <InputLabel>Status</InputLabel>
                    <Select
                        value={newCategory.status}
                        label="Status"
                        onChange={e => setNewCategory({ ...newCategory, status: e.target.value })}
                        variant="outlined"
                        sx={{
                        borderRadius: '8px',
                        '& .MuiSelect-select': {
                            py: 1.5
                        }
                        }}
                        MenuProps={{
                        PaperProps: {
                            sx: {
                            borderRadius: '8px',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                            marginTop: '4px'
                            }
                        }
                        }}
                    >
                        <MenuItem value="active">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <FiCircle size={14} color="#28a745" />
                            Active
                        </Box>
                        </MenuItem>
                        <MenuItem value="inactive">
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                            <FiCircle size={14} color="#6c757d" />
                            Inactive
                        </Box>
                        </MenuItem>
                    </Select>
                    </FormControl>
                </Box>
                </DialogContent>

                <DialogActions sx={{
                px: 3,
                py: 2,
                gap: 2
                }}>
                <Button
                    onClick={handleAddCategoryClose}
                    variant="outlined"
                    sx={{
                    borderRadius: '8px',
                    textTransform: 'none',
                    px: 3,
                    py: 1,
                    border:'1px solid grey',
                    color:"grey",
                    fontWeight: 500,
                    '&:hover': {
                        borderWidth: '1.5px',
                        backgroundColor: '#f8f9fa'
                    }
                    }}
                >
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    onClick={handleAddCategorySubmit}
                    disabled={!newCategory.title}
                    sx={{
                    border:"1px solid black",
                    borderRadius: '8px',
                    textTransform: 'none',
                    px: 3,
                    py: 1,
                    fontWeight: 500,
                    boxShadow: 'none',
                    background: "rgb(43, 51, 58)",
                    color: 'white',
                    '&:hover': {
                        boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                        background: 'rgb(43, 51, 58) '
                    },
                    '&:disabled': {
                        background: '#e9ecef',
                        color: '#adb5bd'
                    }
                    }}
                >
                    Create Category
                </Button>
                </DialogActions>
            </Dialog>
            {/* Add Subcategory Dialog */}
            <Dialog
                open={addSubOpen}
                onClose={handleAddSubCategoryClose}
                maxWidth="sm"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: '12px',
                        boxShadow: '0 8px 32px rgba(0,0,0,0.1)'
                    }
                }}
            >
                <DialogTitle
                    sx={{
                        fontSize: '1.25rem',
                        fontWeight: 600,
                        py: 2,
                        px: 3,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <FiLayers size={20} />
                        Add New Subcategory
                    </Box>
                    <IconButton
                        onClick={handleAddSubCategoryClose}
                        sx={{
                            color: 'text.secondary',
                            '&:hover': {
                                backgroundColor: 'rgba(0,0,0,0.05)'
                            }
                        }}
                    >
                        <FiX size={20} />
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{ py: 3, px: 3 }}>
                    <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 3, mt: 2 }}>
                        {/* Title Field */}
                        <TextField
                            variant="outlined"
                            label="Subcategory Name"
                            value={newSubcategory.title}
                            onChange={e => setNewSubcategory({ ...newSubcategory, title: e.target.value })}
                            fullWidth
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiType color="#6c757d" size={18} />
                                    </InputAdornment>
                                ),
                                sx: { borderRadius: '8px' }
                            }}
                        />

                        {/* Image Upload */}
                        <Box>
                            <Typography variant="subtitle2" sx={{
                                mb: 1,
                                fontWeight: 500,
                                color: 'text.secondary',
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1
                            }}>
                                <FiUploadCloud size={16} />
                                Subcategory Image
                            </Typography>

                            <Box
                                component="label"
                                htmlFor="subcategory-image-upload"
                                sx={{
                                    border: '2px dashed',
                                    borderColor: 'divider',
                                    borderRadius: 2,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    p: 3,
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        borderColor: 'primary.main',
                                        backgroundColor: 'rgba(0, 123, 255, 0.05)'
                                    }
                                }}
                            >
                                {imagePreview ? (
                                    <Box sx={{ position: 'relative', width: '100%' }}>
                                        <img
                                            src={imagePreview}
                                            alt="Preview"
                                            style={{
                                                width: '100%',
                                                maxHeight: 200,
                                                objectFit: 'contain',
                                                borderRadius: 6
                                            }}
                                        />
                                        <IconButton
                                            sx={{
                                                position: 'absolute',
                                                top: 8,
                                                right: 8,
                                                backgroundColor: 'rgba(0,0,0,0.5)',
                                                color: 'white',
                                                '&:hover': {
                                                    backgroundColor: 'rgba(0,0,0,0.7)'
                                                }
                                            }}
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                setImagePreview('');
                                                setNewSubcategory({ ...newSubcategory, image: '' });
                                            }}
                                        >
                                            <FiTrash2 size={16} />
                                        </IconButton>
                                    </Box>
                                ) : (
                                    <>
                                        <FiUploadCloud size={48} color="#adb5bd" style={{ marginBottom: '8px' }} />
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            <Box component="span" sx={{ color: 'primary.main', fontWeight: 500 }}>
                                                Click to upload
                                            </Box> or drag and drop
                                        </Typography>
                                        <Typography variant="caption" sx={{ color: 'text.disabled' }}>
                                            PNG, JPG, GIF (Max 2MB)
                                        </Typography>
                                    </>
                                )}

                                <input
                                    id="subcategory-image-upload"
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    onChange={e => {
                                        const file = e.target.files[0];
                                        if (file) {
                                            setNewSubcategory({ ...newSubcategory, image: file });
                                            setImagePreview(URL.createObjectURL(file));
                                        }
                                    }}
                                />
                            </Box>
                        </Box>

                        {/* Status Selector */}
                        <FormControl fullWidth>
                            <InputLabel>Status</InputLabel>
                            <Select
                                value={newSubcategory.status}
                                label="Status"
                                onChange={e => setNewSubcategory({ ...newSubcategory, status: e.target.value })}
                                variant="outlined"
                                sx={{ borderRadius: '8px' }}
                            >
                                <MenuItem value="active">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <FiCircle size={14} color="#28a745" />
                                        Active
                                    </Box>
                                </MenuItem>
                                <MenuItem value="inactive">
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                        <FiCircle size={14} color="#6c757d" />
                                        Inactive
                                    </Box>
                                </MenuItem>
                            </Select>
                        </FormControl>

                        {/* Category Selector */}
                        <FormControl fullWidth>
                            <InputLabel>Parent Category</InputLabel>
                            <Select
                                value={newSubcategory.category_id}
                                label="Parent Category"
                                onChange={e => setNewSubcategory({ ...newSubcategory, category_id: e.target.value })}
                                variant="outlined"
                                sx={{ borderRadius: '8px' }}
                            >
                                {categories.filter(cat => cat && cat._id && cat.title).map(cat => (
                                    <MenuItem key={cat._id} value={cat._id}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                            <FiLayers size={14} color="#6c757d" />
                                            {cat.title}
                                        </Box>
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Box>
                </DialogContent>

                <DialogActions sx={{ px: 3, py: 2, gap: 2 }}>
                    <Button
                        onClick={handleAddSubCategoryClose}
                        variant="outlined"
                        sx={{
                            borderRadius: '8px',
                            textTransform: 'none',
                            px: 3,
                            py: 1,
                            fontWeight: 500,
                            color: 'grey',
                            borderColor: "grey"
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleAddSubcategorySubmit}
                        disabled={!newSubcategory.title || !newSubcategory.category_id}
                        sx={{
                            border: '1px solid black',
                            borderRadius: '8px',
                            textTransform: 'none',
                            px: 3,
                            py: 1,
                            fontWeight: 500,
                            boxShadow: 'none',
                            background: 'rgb(43, 51, 58)',
                            color: 'white',
                            '&:hover': {
                                background: 'rgb(43, 51, 58)'
                            },
                            '&:disabled': {
                                background: '#e9ecef',
                                color: '#adb5bd'
                            }
                        }}
                    >
                        Create Subcategory
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default ProductForm;